const INGREDIENT_TREE_FIELD_MIN_HEIGHT = 300

export default INGREDIENT_TREE_FIELD_MIN_HEIGHT
